import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { resolvePriceOpen } from '@ecp/common/src/utils/good/goodUtil';
import useGoodOptionItem from '@ecp/common/src/hooks/good/option/useGoodOptionItem';
import moTheme from '@ecp/common/src/style/theme/mo';
import { TextBox } from '@ecp/common/src/text/TextBox';
import { DropdownItemWrapper } from '@ecp/common/src/components/unstyled/dropdown/DropdownDefaultComponent';

import useSiteInfo from '@mo-hooks/common/useSiteInfo';
import SubGoodDropDownItem from '@mo-pages/good/components/SubGoodDropDownItem';

const GoodCtaButtonOptionItem = ({ label, subGoodIndex, leafItem }) => {
  const { isPriceOpen: siteIsPriceOpen, priceFormat } = useSiteInfo();
  // REQ_DS_05_01
  const isPriceOpen = resolvePriceOpen(leafItem?.priceExpsUseYn, siteIsPriceOpen);
  const { disabled, labelWithSalePossibleQuantity, discountPrice } = useGoodOptionItem({
    leafItem,
    label,
    priceFormat,
  });

  return (
    <GoodOptionItemWrapper disabled={disabled}>
      <SubGoodDropDownItem
        width={discountPrice ? 'calc(100% - 90px)' : '100%'}
        padding={'0px'}
        subGoodIndex={subGoodIndex}
        label={labelWithSalePossibleQuantity}
      />
      {isPriceOpen && <TextBox>{discountPrice}</TextBox>}
    </GoodOptionItemWrapper>
  );
};

const GoodOptionItemWrapper = styled(DropdownItemWrapper)`
  justify-content: space-between;
  height: 40px;
  padding: 0 10px;
  font-size: ${moTheme.font.size.$14};
  font-weight: ${moTheme.font.weight.demiLight};
`;

GoodCtaButtonOptionItem.propTypes = {
  label: PropTypes.string,
  subGoodIndex: PropTypes.string,
  leafItem: PropTypes.object,
};

export default GoodCtaButtonOptionItem;
